import { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import TabView from '../../../../components/TabView';
import ServiceHours from './ServiceHours';
import Robot from './Robot';
import Mapping from './Mapping';

const useStyle = makeStyles(() => ({
  root: {
    borderRadius: '0 0.937rem 0.937rem',
    backgroundColor: '#ffffff',
    padding: '1.875rem 1.875rem 0',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  tabBox: {
    display: 'flex',
    paddingBottom: '1.875rem',
    borderBottom: 'solid 0.063rem #d9d9d9',
    width: '100%',
  },
  tabSelected: {
    borderRadius: '20px',
    width: '9.375rem',
    height: '2.5rem',
    backgroundColor: '#538fff',
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    color: '#ffffff',
  },
  tabUnSelected: {
    borderRadius: '20px',
    width: '9.375rem',
    height: '2.5rem',
    backgroundColor: '#f5faff',
    fontSize: '1rem',
    color: '#c0c6cb',
    border: 'solid 1px #c0c6cb',
  },
}));

const Televisit = ({ setLeaveOpen, setContinueFunc }) => {
  const classes = useStyle();

  const tabList = useMemo(
    () => [
      {
        value: 1,
        testID: 'TAB-SERVICE-HOURS',
        title: 'SETTING_TELE_TAB_SERVICE_HOURS',
        component: ServiceHours,
      },
      {
        value: 2,
        testID: 'TAB-ROBOT',
        title: 'SETTING_TELE_TAB_ROBOT',
        component: Robot,
      },
      {
        value: 3,
        testID: 'TAB-MAPPING',
        title: 'SETTING_TELE_TAB_MAPPING',
        component: Mapping,
      },
    ],
    []
  );

  return (
    <div className={classes.root}>
      <TabView
        tabList={tabList}
        selectedClassName={classes.tabSelected}
        unSelectedClassName={classes.tabUnSelected}
        tabBoxClassName={classes.tabBox}
        setLeaveOpen={setLeaveOpen}
        setContinueFunc={setContinueFunc}
      />
    </div>
  );
};

export default Televisit;
